import Vue from 'vue';
import VueCookies from 'vue-cookies';
import App from '@/App.vue';
import IconPlugin from '@/plugins/icon';
import router from '@/router';
import store from '@/store';
import EnvRepository from './repository/EnvRepository';

// install style.
require('@/assets/scss/style.scss');

Vue.config.productionTip = false;

// install plugins, START ====
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function inject(name: string, value: any) {
  const prop = `$${name.replace(/^\$+/g, '')}`;
  Vue.prototype[prop] = Vue.observable(value);
}

Vue.use({
  install() {
    IconPlugin(inject);
  },
});
// install plugins, END ====

// Cookie
const COOKIES_DOMAIN = EnvRepository.getEnv().VUE_APP_COOKIES_DOMAIN;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Vue.use(VueCookies, { domain: COOKIES_DOMAIN, secure: 'true', sameSite: 'none' });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
